<div>

    <svg class="canvas" width="1280" height="720" viewBox="0 0 1280 720" fill="none" xmlns="http://www.w3.org/2000/svg">

        <g class="all"></g>

    </svg>

</div>